import {
  type ButtonProps,
  Button,
  NavigateBeforeRoundedIcon,
  styled,
  Text,
} from '@shared/components';

import { useSidebar } from '../../providers';

const ToggleButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'open',
})<ButtonProps & { open: boolean }>(({ open, theme }) => ({
  borderRadius: theme.shape.rounded(8),
  minWidth: 0,
  '.MuiSvgIcon-root': {
    transform: open ? '' : 'rotate(0.5turn)',
    transition: 'all 400ms ease-in-out',
  },
  margin: 16,
}));

function SidebarToggleButton() {
  const { isOpen, toggle } = useSidebar();
  return (
    <ToggleButton
      variant='outlined'
      color='secondary'
      className='toggle-sidebar'
      startIcon={<NavigateBeforeRoundedIcon />}
      open={isOpen}
      onClick={toggle}
    >
      {isOpen ? <Text variant='body2'>ซ่อนเมนู</Text> : null}
    </ToggleButton>
  );
}

export default SidebarToggleButton;
